import request from 'app/api/request';
import { useMutation, UseMutationResult } from 'react-query';
import { UUID } from './types';
import { dispatchMessage, EventType } from 'app/useToasts';
import { i18n } from 'app/utils/i18n';

export interface CreateTypedMemberValueRequest {
  documentSuperId: number;
  axisConceptId: UUID;
  value: string;
}

export interface CreatedTypedMemberValue {
  id: UUID;
  axisConceptId: UUID;
  value: string;
}

export function useCreateTypedMemberValue(): UseMutationResult<CreatedTypedMemberValue, unknown, CreateTypedMemberValueRequest> {
  return useMutation(
    async (input: CreateTypedMemberValueRequest) => {
      const res = await request.post('/gaby/typed-member-values', input);
      return res?.data as CreatedTypedMemberValue;
    },
    {
      onError: (error: any) => {
        let message = i18n('tag.dimensions.typed-value-save-error');
        try {
          const body = JSON.parse(error.request?.responseText);
          if (body?.error) message = body.error;
        } catch {}
        dispatchMessage(EventType.ADD_MESSAGE, { type: 'error', text: message, removeTime: 4000 });
      },
    }
  );
}
